import React, { useState, useEffect } from "react";
import { Table, Button as AntButton, Space } from "antd";
import moment from "moment";
import CardDiv from "modules/common/card-div/CardDiv";
import OnBoardCX from "./OnBoardCX";
import { useClinicStore } from "./store";
import { Link } from "react-router-dom";
import PrescriptionModal from "./PrescriptionCreationForm";
import { Button, CloseButton, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExpandaleRowView from "./ExpandaleRowView";
import ProductsOffcanvas from "modules/dashboards/actionables/ProductsOffcanvas";
import secureLocalStorage from "react-secure-storage";
import Papa from "papaparse";
import { get, isEmpty } from "lodash";

const ClinicsDashBoard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPrescriptionModalVisible, setIsPrescriptionModalVisible] =
    useState(false);
  const [selectedRecord, setSelectedRecord] = useState([]);
  const {
    getPatientsAssignedToClinics,
    clinicAppointments,
    clinicAppointmentLoading,
    updateClinicPayment
  } = useClinicStore();
  const [appointmentsData, setAppointmentsData] = useState([]);

  const defaultStartDate = moment().toDate();
  const defaultEndDate = moment().add(7, "days").toDate();
  const [tempStartDate, setTempStartDate] = useState(defaultStartDate);
  const [tempEndDate, setTempEndDate] = useState(defaultEndDate);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [view, setView] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const utm_name = secureLocalStorage.getItem("clinic_emp_id");
  const clinicId = secureLocalStorage.getItem("clinic_id");
  const formLink = `https://formv2s.dev.hav-g.in/questions?utm_campaign=${utm_name}`;

  const handleOnboardNewCx = (record = null) => {
    if (!isEmpty(record)) {
      setPhoneNumber(get(record, ['user', 'phone_number'], null));
    }
    setIsModalVisible(true);
  };

  const handleFormSubmit = (formData) => {
    setIsModalVisible(false);
  };

  const handleAddPrescription = (record) => {
    setSelectedRecord(record);
    setIsPrescriptionModalVisible(true);
    setView(false);
  };

  const handleFilterClick = () => {
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);
  };

  const handleDownloadCSV = () => {
    // Prepare the data for CSV export
    const csvData = appointmentsData.map((record) => ({
      "First Name": record?.user?.first_name,
      "Phone Number": record?.user?.phone_number,
      "Request Type": record?.request_type,
      "Appointment Time": moment(record.reminder_date)?.format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      Status: record.is_finished ? "Complete" : "Incomplete",
      "Payment Status": record?.payment_status?.toUpperCase(),
    }));

    // Convert to CSV format using PapaParse
    const csv = Papa.unparse(csvData);

    // Create a blob and trigger download
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "appointments.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    getPatientsAssignedToClinics(startDate, endDate, clinicId);
  }, [startDate, endDate]);

  useEffect(() => {
    setAppointmentsData(clinicAppointments);
  }, [clinicAppointments]);

  const handleViewPrescription = (record) => {
    setView(true);
    setSelectedRecord(record);
    setIsPrescriptionModalVisible(true);
  };

  const handleAction = (record) => {
    updateClinicPayment(record?.payment_id);
    //commented due to may be need in future
    // const hash = `${PAYU_KEY}|${record.payment_id}|${record.amount}|Consult Call|${record.user.first_name}|${record.user.email}|${record.case_id}||||||||||${PAYU_SALT}`;
    // toast.loading("Redirecting to payment....");
    // const payuData = {
    //   key: PAYU_KEY,
    //   txnid: record.payment_id,
    //   productinfo: "Consult Call",
    //   amount: Number(record.amount),
    //   email: record.user.email,
    //   firstname: record.user.first_name,
    //   phone: record.user.phone_number,
    //   udf1: record.user.case_id,
    //   surl: "https://api.dev.hav-g.in/api/clinic/payucallback-confirm-appointment",
    //   furl: "https://api.dev.hav-g.in/api/clinic/payucallback-refund-appointment",
    //   hash: sha512(hash),
    // };
    // alert(JSON.stringify(payuData));
    // const form = document.createElement("form");
    // form.method = "POST";
    // form.action = PAYU_URL;
    // form.target = "_blank";

    // for (const key in payuData) {
    //   if (payuData.hasOwnProperty(key)) {
    //     const input = document.createElement("input");
    //     input.type = "hidden";
    //     input.name = key;
    //     input.value = payuData[key];
    //     form.appendChild(input);
    //   }
    // }
    // document.body.appendChild(form);
    // form.submit();
  }

  const columns = [
    {
      title: "First Name",
      dataIndex: ["user", "first_name"],
      key: "first_name",
      render: (_, record) => (
        <Link to={`/lead-details/${record?.case_id}`}>
          <span className="text-capitalize">{record?.user?.first_name || "N/A"}</span>
        </Link>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: ["user", "phone_number"],
      key: "phone_number",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Request Type",
      dataIndex: "request_type",
      key: "request_type",
    },
    {
      title: "Appointment Time",
      dataIndex: "reminder_date",
      key: "reminder_date",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Status",
      dataIndex: "is_finished",
      key: "is_finished",
      render: (text) => (
        <span style={{ color: text ? "green" : "red" }}>
          {text ? "Complete" : "Incomplete"}
        </span>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      filters: [
        { text: 'Paid', value: 'paid' },
        { text: 'Pending', value: 'pending' },
      ],
      onFilter: (value, record) => record.payment_status === value,
      render: (text) => (
        <span style={{ color: text === 'paid' ? "green" : "red", fontWeight: 'bold' }}>
          {text?.toUpperCase()}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <AntButton type="link" onClick={() => handleViewPrescription(record)}>
            View
          </AntButton>
          <AntButton type="link" onClick={() => handleAddPrescription(record)}>
            Add Prescription
          </AntButton>
          <AntButton type="link" onClick={() => handleAction(record)}>
            Mark as Paid
          </AntButton>
          <div>
            <ProductsOffcanvas
              case_id={record.case_id}
              customerName={record?.user?.first_name}
              orderCount={0}
              user={record.user}
              address={[]}
              billingAddress={[]}
            />
          </div>
          <div>
            <Button type="primary" onClick={() => handleOnboardNewCx(record)}>
              Book Appointment
            </Button>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <CardDiv
      title={"Clinic Appointments"}
      component={
        <div style={{ background: "#fff", borderRadius: "8px" }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
              <Button type="primary" onClick={() => handleOnboardNewCx(null)}>
                Book Appointment
              </Button>
              <a href={formLink} target="_blank">
                <button class="bg-primary border rounded-3 p-2 font-poppins text-white">
                  Take Hair Test
                </button>
              </a>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <DatePicker
                selected={tempStartDate}
                onChange={(date) => setTempStartDate(date)}
                selectsStart
                startDate={tempStartDate}
                endDate={tempEndDate}
                placeholderText="Start Date"
                className="form-control"
              />
              <DatePicker
                selected={tempEndDate}
                onChange={(date) => setTempEndDate(date)}
                selectsEnd
                startDate={tempStartDate}
                endDate={tempEndDate}
                minDate={tempStartDate}
                placeholderText="End Date"
                className="form-control"
              />
              <Button
                variant="primary"
                className="ml-2"
                onClick={handleFilterClick}
              >
                Filter
              </Button>
              <Button
                variant="primary"
                className="ml-2"
                onClick={handleDownloadCSV}
              >
                Download
              </Button>
            </div>
          </div>
          <Table
            dataSource={appointmentsData}
            columns={columns}
            expandable={{
              expandedRowRender: (record) => {
                return (
                  <ExpandaleRowView record={record} />
                );
              },
            }}
            rowKey="_id"
            bordered
            size="middle"
            loading={clinicAppointmentLoading}
          />
          <OnBoardCX
            show={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            handleSubmit={handleFormSubmit}
            startDate={startDate}
            endDate={endDate}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
          />
          <Modal
            show={isPrescriptionModalVisible}
            onHide={() => {
              setIsPrescriptionModalVisible(false);
              setPhoneNumber(null);
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                Clinic Prescription
              </Modal.Title>
              <CloseButton
                className="btn btn-circle btn-sm transition-base p-0"
                onClick={() => setIsPrescriptionModalVisible(false)}
              />
            </Modal.Header>
            <Modal.Body>
              <PrescriptionModal
                caseId={selectedRecord.case_id}
                setIsModalVisible={setIsModalVisible}
                view={view}
                setView={setView}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  setIsPrescriptionModalVisible(false);
                  setPhoneNumber(null);
                }}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      }
    />
  );
};

export default ClinicsDashBoard;
